import { render } from "./Generate.vue?vue&type=template&id=2986ddcb"
import script from "./Generate.vue?vue&type=script&lang=js"
export * from "./Generate.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\beam\\Project\\DAPPS\\beam-dapps\\nft_gallery_fe\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__